import React from 'react';
import PropTypes from 'prop-types';
import css from './edicons.module.less';

const iconContentMap = {
  music: 'e800',
  el: 'e801',
  cancel: 'e802',
  'ok-squared': 'e803',
  'ok-circled2': 'e804',
  'ok-circled1': 'e805',
  ok: 'e806',
  mail: 'e807',
  'mail-alt-1': 'e808',
  heart: 'e809',
  'heart-empty': 'e80a',
  star: 'e80b',
  'star-empty': 'e80c',
  'star-half': 'e80d',
  'star-half-alt': 'e80e',
  child: 'e80f',
  female: 'e810',
  male: 'e811',
  users: 'e812',
  'user-1': 'e813',
  videocam: 'e814',
  picture: 'e815',
  'minus-squared-alt': 'e816',
  'minus-circled': 'e817',
  'minus-squared': 'e818',
  minus: 'e819',
  'plus-squared-alt': 'e81a',
  'plus-squared': 'e81b',
  plus: 'e81c',
  'plus-circled': 'e81d',
  help: 'e81e',
  camera: 'e81f',
  'camera-alt': 'e820',
  th: 'e821',
  'th-list': 'e822',
  'th-large': 'e823',
  search: 'e824',
  math: 'e825',
  'mail-squared': 'e826',
  'help-circled': 'e827',
  'info-circled2': 'e828',
  info: 'e829',
  home: 'e82a',
  link: 'e82b',
  unlink: 'e82c',
  'link-ext': 'e82d',
  'link-ext-alt': 'e82e',
  attach: 'e82f',
  lock: 'e830',
  'lock-open': 'e831',
  'lock-open-alt': 'e832',
  pin: 'e833',
  'thumbs-up': 'e834',
  'thumbs-down': 'e835',
  'thumbs-up-alt': 'e836',
  'thumbs-down-alt': 'e837',
  'download-cloud': 'e838',
  'upload-cloud': 'e839',
  'plus-squared-alt-new': 'e83a',
  'edu-book': 'e83b',
  workbook: 'e83c',
  'quote-left': 'e83d',
  'quote-right': 'e83e',
  'share-squared': 'e83f',
  pencil: 'e840',
  edit: 'e841',
  'pencil-squared': 'e842',
  print: 'e843',
  comment: 'e844',
  chat: 'e845',
  'comment-empty': 'e846',
  location: 'e847',
  'attention-circled2': 'e848',
  attention2: 'e849',
  'attention-alt': 'e84a',
  trash: 'e84b',
  'trash-empty': 'e84c',
  'user-plus': 'e84d',
  'user-times': 'e84e',
  tag: 'e84f',
  tags: 'e850',
  menu: 'e851',
  cog: 'e852',
  'cog-alt': 'e853',
  wrench: 'e854',
  sliders: 'e855',
  'cancel-circled2': 'e856',
  basket: 'e857',
  logout: 'e858',
  login: 'e859',
  'resize-full-alt': 'e85a',
  globe: 'e85b',
  esl: 'e85c',
  block: 'e85d',
  'zoom-in': 'e85e',
  'zoom-out': 'e85f',
  'down-dir': 'e860',
  'up-dir': 'e861',
  'left-dir': 'e862',
  'right-dir': 'e863',
  'down-open': 'e864',
  'left-open': 'e865',
  'up-open': 'e866',
  'right-open': 'e867',
  'angle-left': 'e868',
  'angle-right': 'e869',
  'angle-up': 'e86a',
  'angle-down': 'e86b',
  'angle-circled-left': 'e86c',
  'angle-circled-right': 'e86d',
  'angle-circled-up': 'e86e',
  'angle-circled-down': 'e86f',
  'angle-double-left': 'e870',
  'angle-double-up': 'e871',
  'angle-double-right': 'e872',
  'angle-double-down': 'e873',
  beaker: 'e874',
  bank: 'e875',
  'graduation-cap': 'e876',
  'cc-stripe': 'e877',
  'down-big': 'e878',
  'left-big': 'e879',
  'right-big': 'e87a',
  'up-big': 'e87b',
  'cc-visa': 'e87c',
  'cc-mastercard': 'e87d',
  'cc-discover': 'e87e',
  'cc-amex': 'e87f',
  'down-open-1': 'e880',
  ccw: 'e881',
  'arrows-cw': 'e882',
  'cc-paypal': 'e883',
  android: 'e884',
  apple: 'e885',
  expand: 'e886',
  collapse: 'e887',
  'expand-right': 'e888',
  'collapse-left': 'e889',
  play: 'e88a',
  clock: 'e88b',
  chrome: 'e88c',
  stop: 'e88d',
  pause: 'e88e',
  laptop: 'e88f',
  desktop: 'e890',
  tablet: 'e891',
  mobile: 'e892',
  inbox: 'e893',
  worksheet: 'e894',
  spin: 'e895',
  reading: 'e896',
  'list-bullet': 'e897',
  'list-numbered': 'e898',
  science: 'e899',
  check: 'e89a',
  'social-studies': 'e89b',
  writing: 'e89c',
  palette: 'e89d',
  share: 'e89e',
  'sort-up': 'e89f',
  'sort-down': 'e8a0',
  sort: 'e8a1',
  'cancel-circled': 'e8a2',
  bell: 'e8a3',
  story: 'e8a4',
  set: 'e8a5',
  'science-project': 'e8a6',
  'lesson-plan': 'e8a7',
  'up-open-1': 'e8a8',
  'right-dir-1': 'e8a9',
  'down-dir-1': 'e8aa',
  'up-dir-1': 'e8ab',
  award: 'e8ac',
  activity: 'e8ad',
  'skill-builder': 'e8ae',
  cc: 'e8af',
  floppy: 'e8b0',
  points: 'e8b1',
  collect: 'e8b2',
  eraser: 'e8b3',
  'volume-off': 'e8b4',
  'volume-low': 'e8b5',
  'volume-medium': 'e8b6',
  'volume-high': 'e8b7',
  'edu-logo': 'e8b8',
  pointer: 'e8b9',
  brush: 'e8ba',
  'resize-full': 'e8bb',
  'resize-small': 'e8bc',
  left: 'e8bd',
  down: 'e8be',
  right: 'e8bf',
  up: 'e8c0',
  calendar: 'e8c1',
  braille: 'e8c2',
  diamond: 'e8c3',
  'logo-mark': 'e8c4',
  user: 'e8c5',
  'attention-circled': 'e8c6',
  'cancel-light': 'e8c7',
  attention: 'e8c8',
  'info-circled': 'e8c9',
  'ok-circled': 'e8ca',
  'set-new': 'e8cb',
  'ok-new': 'e8cc',
  'play-circled2': 'e8cd',
  'diamond-outline': 'e8ce',
  'guided-lessons': 'e8cf',
  progress: 'e8d0',
  bookmark: 'e8d1',
  'bookmark-filled': 'e8d2',
  'plus-light': 'e8d3',
  'trash-light': 'e8d4',
  'move-to': 'e8d5',
  'more-vert': 'e8d6',
  'child-face': 'e8d7',
  'eye-off': 'e8d8',
  'mail-alt': 'e8d9',
  flame: 'e8ee',
  'guided-lesson': 'e8ef',
  twitter: 'f099',
  facebook: 'f09a',
  gauge: 'f0e4',
  gamepad: 'f11b',
  mic: 'f130',
  mute: 'f131',
  ellipsis: 'f141',
  'ellipsis-vert': 'f142',
  youtube: 'f167',
  windows: 'f17a',
  'paper-plane': 'f1d8',
  wifi: 'f1eb',
  'chart-line': 'f201',
  pinterest: 'f231',
  medium: 'f23a',
  safari: 'f267',
  firefox: 'f269',
  ie: 'f26b',
  monitor: 'f26c',
  'map-pin': 'f276',
  edge: 'f282',
};

const Icon = ({ name, className, ...otherProps }) => {
  if (!iconContentMap[name]) {
    console.error('Unknown icon', name);
    return null;
  }

  const classes = [css.icon, 'edicon', 'icon-' + name, className];

  return (
    <i
      className={classes.join(' ')}
      {...otherProps}
      dangerouslySetInnerHTML={{ __html: '&#x' + iconContentMap[name] + ';' }}
      role="img"
    />
  );
};

Icon.propTypes = {
  name: PropTypes.string.isRequired,
  className: PropTypes.string,
};

export default Icon;
